import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { marked } from "marked";
import { fetchPage } from "../lib/api.js";
import { useI18n } from "../i18n/index.js";
import { NotFound } from "./NotFound.js";
import styles from "./StaticPage.module.css";

type Slug = "imprint" | "privacy" | "credits";

type LoadState = { status: "loading" } | { status: "error" } | { status: "ready"; html: string };

export function StaticPage({ slug }: { slug: Slug }) {
  const { lang, t } = useI18n();
  const [state, setState] = useState<LoadState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading" });
    fetchPage(slug, lang)
      .then((page) => {
        if (cancelled) return;
        if (!page) {
          setState({ status: "error" });
          return;
        }
        setState({
          status: "ready",
          html: marked.parse(page.markdown, { async: false, breaks: true }),
        });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, [slug, lang]);

  if (state.status === "loading") return null;
  if (state.status === "error") return <NotFound message={t("page.loadError")} />;

  return (
    <main className={styles.main}>
      <Link to="/" className={styles.backLink}>
        ← {t("common.backHome")}
      </Link>
      {/* Content is authored exclusively by the admin (trusted, not user input). */}
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: state.html }} />
    </main>
  );
}
